import { CSSProperties } from 'react';
import s from './DropdownBlock.module.scss';

export const DropdownBlock = ({children, open, style}: {children: React.ReactNode, open?: boolean, style?: CSSProperties}) => {

    // ### State

    // ### Effects

    // ### Functions

    // ### Views

    return(
        <div className={`${s.dropdown} ${open ? s.open : ""}`}>
            <div className={s.content} style={style}>{children}</div>
        </div>
    )
}